/** @format */

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { chain } from '@core/chain';
import { startHoneycomb } from '@shared/ssr-core/data-access';
import { AppBrowserModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

// Is Honeycomb enabled for the current chain?
if (environment.killSwitch?.honeycombEnabled?.[chain.chainIdentifierAbbr]) {
  startHoneycomb(
    environment.thirdParty.honeycomb.apiKey,
    environment.thirdParty.honeycomb.serviceName,
    'home',
    chain.chainIdentifierAbbr,
  );
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic()
    .bootstrapModule(AppBrowserModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((error) => {
      return console.error(
        `APPLICATION_ERROR:BOOTSTRAP_ERROR: ${JSON.stringify(error, [
          'message',
          'arguments',
          'type',
          'name',
        ])}`,
      );
    });
});
